import { cloneElement, ReactElement } from "react"
import SegmentedButtonGroup from "./SegmentedButtonGroup"

type ButtonProps = {
    value: string
    tooltip: string
    icon: ReactElement
}

interface Props {
    selectedButton: ButtonProps
    unselectedButton: ButtonProps
    property: string
    value: string
    handleOnChange: (property: any, value: any) => void
}

/**
 * An on / off icon button (bold, italic, wrap…) in the same look as every other icon button
 * of the panel (see SegmentedButtonGroup). Fills its column; the tooltip says what the
 * current state is.
 */
const ButtonSwitch = ({
    selectedButton,
    unselectedButton,
    value,
    property,
    handleOnChange,
}: Props) => {
    const isSelected: boolean = value === selectedButton.value
    const b: ButtonProps = isSelected ? selectedButton : unselectedButton

    const handleToggle = () =>
        handleOnChange(property, isSelected ? unselectedButton.value : selectedButton.value)

    return (
        <SegmentedButtonGroup
            segments={[
                {
                    title: b.tooltip,
                    icon: cloneElement(b.icon, { fontSize: "small" }),
                    onClick: handleToggle,
                    selected: isSelected,
                },
            ]}
        />
    )
}

export default ButtonSwitch
